import {Inject, Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AuthenticationService {
  public token: string;

  constructor(@Inject('isBrowser') isBrowser:any, private apiService: ApiService){
    if(isBrowser){
      // set token if saved in local storage
      var currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.token = currentUser && currentUser.token;
    }
  }

  login(username: string, password: string): Observable<boolean> {
    return this.apiService.post('/api/administration/login',JSON.stringify({ username : username, password : password }))
      .map((response: any) => {
        let token = response.token;
        if (token) {
          // set token property
          this.token = token;

          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify({ username: username, token: token }));

          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      });
  }

  //TODO
  logout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('currentUser');
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/authentication.service.ts